module.exports = __webpack_public_path__ + "img/1502774926.15519883.jpg";